/**
 * Centralized logger utility
 * Only logs in development environment
 */

const isDevelopment = process.env.NODE_ENV === "development";

const logger = {
    log: (...args) => {
        if (isDevelopment) {
            logger.log(...args);
        }
    },
    error: (...args) => {
        if (isDevelopment) {
            logger.error(...args);
        }
    },
    warn: (...args) => {
        if (isDevelopment) {
            logger.warn(...args);
        }
    },
    info: (...args) => {
        if (isDevelopment) {
            console.info(...args);
        }
    },
};

export default logger;
